/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_MASTER_CONTRACTS_ALL_REQUEST,
  FETCH_MASTER_CONTRACTS_ALL_SUCCESS,
  FETCH_MASTER_CONTRACTS_ALL_FAILURE,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_MASTER_CONTRACTS_ALL_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_MASTER_CONTRACTS_ALL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_MASTER_CONTRACTS_ALL_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const masterContractsAll = combineReducers({
  list,
});

export default masterContractsAll;
